import React, { ReactElement } from 'react'
import DOMPurify from 'dompurify'
import { styled, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material'

interface ITooltipComponentProps {
	type?: 'html' | 'bootstrap' | 'light';
	arrow?: boolean;
	child: ReactElement<any, any>;
	// eslint-disable-next-line @typescript-eslint/ban-types
	title: string | number | boolean | React.ReactElement<any, string | ((props: any) => (React.ReactElement<any, any> | null)) | {
		new(props: any): React.Component<any, any, any>
	}> | React.ReactNode[] | React.ReactPortal;
	placement?: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top' | undefined;
}

const HtmlTooltip = styled(({ className, children, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}>{children}</Tooltip>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: `1px solid ${theme.palette.primary.main}`,
    '& .MuiTooltip-arrow': {
      color: theme.palette.primary.main,
    },
  },
}))

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}/>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[3],
    padding: 15,
    fontSize: 16,
  },
}))

const TooltipComponent: React.FC<ITooltipComponentProps> = (props) => {
  const placement: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top' | undefined = props.placement ? props.placement : 'bottom-end'
  const type = props.type || 'bootstrap'
  const arrow = props.arrow || true
  return (
    <>
      {type === 'html' && (
        <HtmlTooltip title={props.title} placement={placement} arrow={arrow}>
          {props.child}
        </HtmlTooltip>
      )}
      {type === 'light' && (
        <LightTooltip
          title={
            <Typography
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.title as string, { ADD_ATTR: ['target'] }) }}/>
          }
          placement={placement}
          arrow={arrow}
        >
          {props.child}
        </LightTooltip>
      )}
      {type === 'bootstrap' && (
        <Tooltip title={props.title} placement={placement} arrow={arrow}>
          {props.child}
        </Tooltip>
      )}
    </>
  )
}
export default TooltipComponent
